import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { Experience } from './model'

const { getAll, getCollection, itemGetter } = collectionGetters(adapter, {
  constructor: data => new Experience(data)
})


export default {
  getAll,
  getCollection,
  getExperience: itemGetter,
}
